/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlogManagerListArticleRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: BlogManagerListArticleRequest.direction | null;
    status?: string | null;
    title?: string | null;
};

export namespace BlogManagerListArticleRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

